import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import { DatePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { inputSx, inputLabelSx, labelContainerSx, requiredAsteriskSx } from './Input.styles';

interface DatePickerInputProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  label?: string;
  placeholder?: string;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
}

export const DatePickerInput = ({
  value,
  onChange,
  isOpen,
  onOpen,
  onClose,
  label,
  placeholder = 'Select Date',
  fullWidth = true,
  error = false,
  helperText,
  required = false
}: DatePickerInputProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={labelContainerSx}>
        {label && (
          <Typography sx={inputLabelSx} component="label">
            {label}
            {required && (
              <Box component="span" sx={requiredAsteriskSx}>
                *
              </Box>
            )}
          </Typography>
        )}
        <DatePicker
          open={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          value={value}
          onChange={(newValue) => {
            onChange(newValue);
            onClose();
          }}
          PopperProps={{
            placement: 'bottom-start',
            modifiers: [
              {
                name: 'flip',
                enabled: true,
                options: {
                  fallbackPlacements: ['top-start', 'bottom-start', 'top', 'bottom']
                }
              },
              {
                name: 'preventOverflow',
                enabled: true,
                options: {
                  rootBoundary: 'viewport',
                  tether: false,
                  altAxis: true
                }
              }
            ]
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth={fullWidth}
              placeholder={placeholder}
              sx={inputSx}
              onClick={onOpen}
              error={error}
              helperText={helperText}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    <EventIcon
                      sx={{ cursor: 'pointer', color: 'var(--color-text-tertiary)' }}
                      onClick={onOpen}
                    />
                  </InputAdornment>
                )
              }}
              inputProps={{
                ...params.inputProps,
                readOnly: true
              }}
            />
          )}
        />
      </Box>
    </LocalizationProvider>
  );
};

